const ToastrLevelsEnum = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    WARN: 'WARN',
    INFO:'INFO',
    DEFAULT: 'DEFAULT'
};


export default ToastrLevelsEnum;


// WEBPACK FOOTER //
// ./src/services/enums/toastrLevelsEnum.js